import {useQuery,useMutation,useQueryClient} from 'react-query';
import {GetHourlyStepCountChart,GetOperatorStepCountChart} from '../Api/index'

// const useGetHourlyStepCountChart = (body) => {
//   return useQuery(
//     ['GetHourlyStepCountChart', body], 
//     GetHourlyStepCountChart,
//     {
//       enabled: !!body,
//       refetchOnWindowFocus: false,

//       cacheTime: Infinity, // کش همچنان بی‌نهایت باقی می‌ماند
//       onSuccess: (data) => {
//         // console.log('Success:', data);
//       },
//       onError: (err) => {
//         // console.log('Error:', err);
//       },
//       select: (dt) => {
//         let{data:{data}}=dt;
//         return data
//       } // تغییر شکل داده‌ها (اختیاری)
//     }
//   );
// };

const useGetHourlyStepCountChart=()=>{
//   const dispatch=useDispatch()
  return useMutation(GetHourlyStepCountChart,{
    onSuccess:(data)=>{
      let rawData=data?.data.data;
      // console.log(rawData)
      // console.log(rawData)
    // console.log(data)
    // dispatch(updateCustomerMachineInfoR(rawData))
    }
    ,
    onError:(err)=>{
    // console.log(err)
    },

  })
}

// GetOperatorStepCountChart

const useGetOperatorStepCountChart=()=>{
//   const dispatch=useDispatch()
  return useMutation(GetOperatorStepCountChart,{
    onSuccess:(data)=>{
      let rawData=data?.data.data;
      // console.log(rawData)
      return rawData

    }
    ,
    onError:(err)=>{
    // console.log(err)
    },

  })
}
export {
    useGetHourlyStepCountChart,
    useGetOperatorStepCountChart
}